import { render, staticRenderFns } from "./business-division-select.vue?vue&type=template&id=25fdb596&scoped=true&"
import script from "./business-division-select.vue?vue&type=script&lang=ts&"
export * from "./business-division-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25fdb596",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Sources\\nothegger.topwm\\Nothegger.TopWM.Warehouse.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fdb596')) {
      api.createRecord('25fdb596', component.options)
    } else {
      api.reload('25fdb596', component.options)
    }
    module.hot.accept("./business-division-select.vue?vue&type=template&id=25fdb596&scoped=true&", function () {
      api.rerender('25fdb596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/products/components/business-division-select.vue"
export default component.exports